module.exports = __webpack_public_path__ + "img/wheelock.54f63195.jpg";